import { render, staticRenderFns } from "./SelfCertn.vue?vue&type=template&id=212aa537&scoped=true"
import script from "./SelfCertn.vue?vue&type=script&lang=js"
export * from "./SelfCertn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212aa537",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('212aa537')) {
      api.createRecord('212aa537', component.options)
    } else {
      api.reload('212aa537', component.options)
    }
    module.hot.accept("./SelfCertn.vue?vue&type=template&id=212aa537&scoped=true", function () {
      api.rerender('212aa537', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/auth/SelfCertn.vue"
export default component.exports